export const streamAsyncIterator = async function* <T>(stream: ReadableStream<T>) {
  const reader = stream.getReader();
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    reader.releaseLock();
  }
};
